export const CHECKOUT_URL = 'https://decisionclinica.impultienda.ar/checkout/ofm'

export const PIXEL_ID = '2095498077846022'
